import {
	UntypedFormArray,
	UntypedFormGroup,
	UntypedFormControl,
	Validators,
} from '@angular/forms';

export interface CallingTreeSuperCoordinatorJSON {
	branch: number;
	userId: number;
}

export class CallingTreeSuperCoordinator {
	constructor(
		public branch: number,
		public userId: number
	) {}

	static fromJSON(
		json: CallingTreeSuperCoordinatorJSON
	): CallingTreeSuperCoordinator {
		return Object.assign(
			Object.create(CallingTreeSuperCoordinator.prototype),
			json,
			{}
		);
	}

	static createFormArray(
		superCoordinators: CallingTreeSuperCoordinator[]
	): UntypedFormArray {
		return superCoordinators
			? new UntypedFormArray(
					superCoordinators.map((sc) => this.createFormGroup(sc))
				)
			: new UntypedFormArray([]);
	}

	static createFormGroup(
		superCoordinator: CallingTreeSuperCoordinator
	): UntypedFormGroup {
		return new UntypedFormGroup({
			branch: new UntypedFormControl(superCoordinator.branch),
			userId: new UntypedFormControl(
				superCoordinator ? superCoordinator.userId : null,
				[Validators.required]
			),
		});
	}

	static fromFormArray(fa: UntypedFormArray): CallingTreeSuperCoordinator[] {
		return fa.length > 0
			? fa.controls.map((fg: UntypedFormGroup) => this.fromFormGroup(fg))
			: [];
	}

	static fromFormGroup(fg: UntypedFormGroup): CallingTreeSuperCoordinator {
		return Object.assign(
			Object.create(CallingTreeSuperCoordinator.prototype),
			{
				branch: fg.get('branch').value,
				userId: fg.get('userId').value,
			}
		);
	}
}
